<script setup lang="ts">
import Skeleton from '@/application/components/ui/Skeleton.vue';

</script>

<template>
  <div class="flex flex-col gap-5">
    <Skeleton gradient class="w-full h-12" />
    <Skeleton gradient class="w-full h-12" />
    <Skeleton gradient class="w-full h-12" />
    <Skeleton gradient class="w-full h-12" />
  </div>
</template>
